import { dealTypeFromJsonQuery, FDealType, getRangeValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'roomsInDeal' as const;

export const roomsInDealTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const roomsInDeal = getRangeValue('rooms_for_sale')(jsonQuery);

    if (roomsInDeal === null) {
      return null;
    }

    const dealType = dealTypeFromJsonQuery(jsonQuery);

    const label = `Комнат ${dealType === FDealType.Sale ? `на продажу` : `в аренду`}: от ${roomsInDeal}`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['rooms_for_sale'])(jsonQuery),
};
